/**
 * Shared phase constants — single source of truth.
 * Previously duplicated across Focus.jsx, FlowRunner.jsx,
 * FlowTimeline.jsx, MiniPlayer.jsx, and PhaseBadge.jsx.
 */
import { Brain, Coffee, NotebookPen, ListTodo, Pencil } from 'lucide-react';

/**
 * Phase accents as semantic tokens (--phase-*) so light, dark, and Stage
 * each resolve their own value. Works in SVG stroke attributes and inline
 * styles alike; for translucent glows wrap with
 * color-mix(in srgb, <color> N%, transparent) — never string-concat a hex alpha.
 */
export const PHASE_COLORS = {
    prep: 'var(--phase-prep)',
    focus: 'var(--phase-focus)',
    reflect: 'var(--phase-reflect)',
    rest: 'var(--phase-rest)',
};

export const PHASE_LABELS = {
    prep: 'PREPARING',
    focus: 'FOCUSING',
    reflect: 'REFLECTING',
    rest: 'RECHARGING',
};

export const PHASE_LABELS_SHORT = {
    prep: 'PREP',
    focus: 'FOCUS',
    reflect: 'REFLECT',
    rest: 'RECHARGE',
};

export const PHASE_ICONS = {
    prep: ListTodo,
    focus: Brain,
    reflect: NotebookPen,
    rest: Coffee,
};

/** Flow uses Pencil for prep instead of ListTodo */
export const PHASE_ICONS_FLOW = {
    prep: Pencil,
    focus: Brain,
    reflect: NotebookPen,
    rest: Coffee,
};

export const PHASE_ORDER = ['prep', 'focus', 'reflect', 'rest'];
